var _ellipse, _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInferiorEsquerda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 60,
    rx: 40,
    ry: 25,
    fill: "#fff",
    stroke: "#1976d2",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 30,
    height: 30,
    fill: "#90caf9",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 85,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#1976d2"
  }, "Inferior Esquerda")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInferiorEsquerda);
export default __webpack_public_path__ + "static/media/inferior-esquerda.d3d62f349eb1525b992f4e69a7280155.svg";
export { ForwardRef as ReactComponent };